'use client';

import { PropsWithChildren, useEffect, useState } from 'react';

import { useIsPageOwner } from '../../hooks/useIsPageOwner';

const MAX_CHECKS = 50;

export const HeapEventEnricher = ({ children }: PropsWithChildren) => {
  const [heapLoaded, setHeapLoaded] = useState<boolean>(
    typeof window !== 'undefined' && !!window.heap?.loaded,
  );
  const isPageOwner = useIsPageOwner();

  useEffect(() => {
    // The heap script is loaded lazily so we can't guarantee it will be loaded when this component is rendered
    let checkCount = 0;

    const intervalId = setInterval(() => {
      if (checkCount > MAX_CHECKS) {
        cleanup();
      }

      if (window.heap?.loaded) {
        setHeapLoaded(true);
        cleanup();
      }

      checkCount++;
    }, 100);

    function cleanup() {
      clearInterval(intervalId);
    }

    return cleanup;
  }, []);

  useEffect(() => {
    if (!heapLoaded) {
      return;
    }

    window.heap?.clearEventProperties();
    window.heap?.addEventProperties({
      isPageOwner,
    });
  }, [isPageOwner, heapLoaded]);

  return <>{children}</>;
};
